import { api, API_BASE_URL } from '@/config/api';

// NOTE: Password is sent to our backend over HTTPS for registration. This is an acceptable
// trade-off since the backend creates Firebase users server-side with custom claims.
// The password is never stored by our backend — it is forwarded to Firebase Auth only.
export const authApi = {
  register: async (data: { email: string; password: string; role: string }) => {
    // Use the configured API base URL (already validated for production)
    const baseUrl = import.meta.env.VITE_API_URL || API_BASE_URL.replace('/api/v2', '');
    const response = await fetch(`${baseUrl}/api/v2/auth/register/public`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });
    
    const result = await response.json();
    
    if (!response.ok || !result.success) {
      throw new Error(result.error?.message || 'Registration failed');
    }
    
    return result;
  },
  
  refreshClaims: async (token: string) => {
    return api.post('/auth/refresh-claims', {}, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  }
};